// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1WPU8","gfeWrapper":"CalendarEvent_gfeWrapper__26G6s"};